export default __webpack_public_path__ + "static/aed-419b9dcad023467fdb115be025cff1dc.jpg";